import { FC } from 'react';

import { Button, styled } from '@mui/material';

import { ButtonWithEyeType } from './types';

import EyeCloseIcon from '@/assets/icons/eye-closed.svg?react';
import EyeOpenIcon from '@/assets/icons/eye-open.svg?react';

const StyledButton = styled(Button)({
  position: 'relative',
  zIndex: 1,
  height: '26px',
  width: '128px',
  transition: 'background-color 0.9s ease',
  border: '1px solid #232b95',
  borderRadius: '3px',
  color: '#fff',
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '16px',
  padding: 0,
  '&:hover': {
    border: '1px solid #232b95',
    filter: 'drop-shadow(0px 2px 15px rgba(122, 137, 167, 25%))',
  },
  '& .MuiButton-startIcon': {
    pointerEvents: 'none',
  },
});

export const ButtonWithEye: FC<ButtonWithEyeType> = ({ title, isOpen, onClick }) => {
  return (
    <StyledButton
      style={{ background: isOpen ? '#232b95' : '#fff', color: isOpen ? '#fff' : '#232b95' }}
      onClick={onClick}
      startIcon={isOpen ? <EyeCloseIcon color="#fff" /> : <EyeOpenIcon color="#232b95" />}
    >
      {title}
    </StyledButton>
  );
};
